export const EXAMOD_LINK = 'https://examod.com/';
export const TERMS_AND_CONDITIONS_LINK = 'https://examod.com/terms-and-conditions/';
export const PRIVACY_POLICY_LINK = 'https://examod.com/privacy-policy/';
export const ABOUT_US_LINK = 'https://examod.com/about-us/';